const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const SEAT_TOKEN_KEY = 'ba-seat-token';

async function request(path, { token, ...options } = {}) {
  const isForm = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const response = await fetch(`${BACKEND_URL}/api/v1${path}`, {
    ...options,
    headers: {
      ...(options.body && !isForm ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = data.detail;
    const shaped = typeof detail === 'object' && detail ? detail : data;
    const message = typeof detail === 'string'
      ? detail : shaped.detail || shaped.code || data.message || `Seat request failed: ${response.status}`;
    const error = new Error(message);
    Object.assign(error, data, shaped, { status: response.status });
    throw error;
  }
  return data;
}

const body = (value) => JSON.stringify(value);

export const lookupClass = (code) => request('/join/lookup', { method: 'POST', body: body({ code }) });
export const claimSeat = (value) => request('/join/claim', { method: 'POST', body: body(value) });
export const joinNewSeat = (value) => request('/join/new', { method: 'POST', body: body(value) });
export const repickSeat = (value) => request('/join/repick', { method: 'POST', body: body(value) });
export const signInSeat = (value) => request('/join/signin', { method: 'POST', body: body(value) });
export const signInWithBackup = (value) => request('/join/backup', { method: 'POST', body: body(value) });
export const claimSeatPictures = (token, value) => request('/seat/claim-pictures', { method: 'PUT', token, body: body(value) });
export const loadSeatSession = (token) => request('/seat/session', { token });
export const loadSeatState = (token) => request('/seat/state', { token });
export const loadSeatBeat = (token, slot) => request(`/seat/beats/${slot}`, { token });
export const createSeatBeat = (token) => request('/seat/beats', { method: 'POST', token });
export const saveSeatBeat = (token, slot, value) => request(`/seat/beats/${slot}`, { method: 'PUT', token, body: body(value) });
export const updateSeatBeat = (token, slot, value) => request(`/seat/beats/${slot}`, { method: 'PATCH', token, body: body(value) });
export const deleteSeatBeat = (token, slot) => request(`/seat/beats/${slot}`, { method: 'DELETE', token });
export const reportSeatSaveStatus = (token, value) => request('/seat/save-status', { method: 'PUT', token, body: body(value) });
export const reserveSeatTakeHome = (token, slot) => request(`/seat/beats/${slot}/takehome/reserve`, { method: 'POST', token });
export const uploadSeatTakeHome = (token, slot, { mp3, revision, reservationId }) => {
  const form = new FormData();
  form.append('mp3', mp3, `beat-arranger-beat-${slot}.mp3`);
  form.append('revision', String(revision));
  form.append('reservation_id', reservationId);
  return request(`/seat/beats/${slot}/takehome`, { method: 'PUT', token, body: form });
};
export const getSeatTakeHome = (token, slot) => request(`/seat/beats/${slot}/takehome`, { token });
export const signOutSeat = (token) => request('/seat/signout', { method: 'POST', token });
